import React from "react";

import { Banner } from "shared/ui/Banner";
import { Button } from "shared/ui/Button";
import { ConfirmDialog } from "shared/ui/ConfirmDialog";
import { EmptyState } from "shared/ui/EmptyState";
import { NotificationSnackbar } from "shared/ui/NotificationSnackbar";
import { PageHeaderActions } from "shared/ui/PageHeaderActions";
import { Skeleton } from "shared/ui/Skeleton";

import { PartnerAccountDialog } from "./components/PartnerAccountDialog";
import { PartnerFormDialog } from "./components/PartnerFormDialog";
import { PartnersTable } from "./components/PartnersTable";
import { usePartnersState } from "./hooks/usePartnersState";

export const Partners = () => {
    const state = usePartnersState();

    const renderBody = () => {
        if (state.error) {
            return (
                <Banner tone="danger" title="Не удалось загрузить партнёров">
                    <Button size="small" variant="outlined" color="neutral" onClick={state.onRetry}>
                        Повторить
                    </Button>
                </Banner>
            );
        }

        if (state.loading) return <Skeleton height="240px" />;

        if (state.partners.length === 0) return <EmptyState title="Партнёров пока нет" />;

        return (
            <PartnersTable
                items={state.partners}
                onEdit={state.onStartEditing}
                onChangeAccount={state.onStartChangingAccount}
                onDelete={state.onStartDeleting}
            />
        );
    };

    const renderDialog = () => {
        const { dialog } = state;

        if (!dialog) return null;

        switch (dialog.kind) {
            case "create":
            case "edit":
                return (
                    <PartnerFormDialog
                        partner={dialog.kind === "edit" ? dialog.partner : null}
                        saving={state.saving}
                        onClose={state.onCloseDialog}
                        onSubmit={state.onSubmitForm}
                    />
                );
            case "account":
                return (
                    <PartnerAccountDialog
                        partner={dialog.partner}
                        saving={state.saving}
                        onClose={state.onCloseDialog}
                        onSubmit={state.onSubmitAccount}
                    />
                );
            case "delete":
                return (
                    <ConfirmDialog
                        open
                        title="Удалить партнёра?"
                        description={`${dialog.partner.name} потеряет доступ в админку. Партнёра с заведениями удалить нельзя.`}
                        confirmLabel="Удалить"
                        tone="danger"
                        saving={state.saving}
                        onClose={state.onCloseDialog}
                        onConfirm={state.onConfirmDelete}
                    />
                );
        }
    };

    return (
        <>
            <PageHeaderActions>
                <Button onClick={state.onStartCreating}>Добавить партнёра</Button>
            </PageHeaderActions>

            {renderBody()}
            {renderDialog()}

            <NotificationSnackbar {...state.notify.snackbarProps} />
        </>
    );
};
